import React from 'react';
import { motion } from 'framer-motion';

interface SegmentOption {
  id: string;
  label: string;
}

interface IOSSegmentedControlProps {
  options: SegmentOption[];
  selectedId: string;
  onChange: (id: string) => void;
  className?: string;
}

/**
 * iOS 风格的分段控制器组件
 */
export const IOSSegmentedControl: React.FC<IOSSegmentedControlProps> = ({
  options,
  selectedId,
  onChange,
  className = '',
}) => {

  return (
    <div
      className={`relative bg-ios-gray5 dark:bg-ios-dark-gray4 rounded-ios-lg p-1 overflow-hidden ${className}`}
      role="group"
    >
      {/* 背景选中指示器 */}
      <motion.div
        className="absolute top-1 bottom-1 rounded-ios-md bg-white dark:bg-ios-dark-gray5 shadow-ios-sm"
        initial={false}
        animate={{
          // 增加边距，防止高亮块贴边
          left: `calc(${(options.findIndex(opt => opt.id === selectedId) * 100) / options.length}% + 0.125rem)`,
          width: `calc(${100 / options.length}% - 0.25rem)`,
        }}
        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
      />

      {/* 选项按钮 */}
      <div className="relative flex">
        {options.map((option) => (
          <button
            key={option.id}
            className={`flex-1 py-1.5 px-2 text-center z-10 transition-colors outline-none ${
              selectedId === option.id
                ? 'text-ios-black dark:text-white'
                : 'text-ios-gray dark:text-ios-dark-gray'
            } text-sm font-medium`}
            onClick={() => onChange(option.id)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};
